import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotEdit = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                fillRule="evenodd"
                d="M17.798 6.933c-3.35.756-8.67 2.033-12.548 5.833-3.878 3.81-6.665 10.498-4.485 14.332 2.192 3.823 9.352 4.78 15.657 6.315 6.317 1.545 11.77 3.665 15.58 1.95 3.798-1.713 5.934-7.25 7.07-12.02 1.145-4.77 1.27-8.762.156-12.1-1.1-3.337-3.462-6.01-6.148-6.89-2.698-.868-5.732.046-8.127.813-2.394.766-3.795 1-7.155 1.767Z"
                clipRule="evenodd"
            />
            <path
                stroke={color}
                strokeWidth={strokeWidth}
                d="m18.984 9.486 5.338-5.338a1.359 1.359 0 0 1 1.921 0l9.61 9.607c.53.53.53 1.39 0 1.921l-5.34 5.339M18.984 9.486 4.148 24.324c-.255.255-.398.6-.398.961v9.607c0 .75.608 1.358 1.359 1.358h9.606c.36 0 .706-.143.96-.398l14.838-14.837M18.984 9.486l11.53 11.529"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotEdit.displayName = "SpotEdit";
